import React, { useEffect } from 'react'
import Header from '../components/layout/header'
import Footer from '../components/layout/footer'
import { Link, Outlet } from 'react-router-dom'
import Head from '../components/layout/Head'

function RootLayout() {
  const scrollToPosition = () => {
        const isMobile = window.innerWidth <= 768;
        const scrollPosition = isMobile
            ? document.documentElement.scrollHeight / 4
            : document.documentElement.scrollHeight / 3;

        window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
        });
    };
  useEffect(()=>{
          if(window.location.pathname == '/home/all')
          {
              scrollToPosition();
          }
      },[Link])
  return (
    <div className="layout-container">
      <Head/>
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

export default RootLayout